import React, { PropsWithChildren } from 'react';

import type { UserResponse } from 'belo-js-sdk';
import type { DefaultBeloChatGenerics } from '../../../../types/types';

export type MentionProps<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = PropsWithChildren<{
  node: {
    mentionedUser: UserResponse<BeloChatGenerics>;
  };
}>;

export const Mention = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>({
  children,
  node: { mentionedUser },
}: MentionProps<BeloChatGenerics>) => (
  <span className='str-chat__message-mention' data-user-id={mentionedUser.id}>
    {children}
  </span>
);
